import * as lmsService from '../core/lms';
import _get from 'lodash/get';
import _map from 'lodash/map';
import * as actions from '../redux/constants';
import { SEARCH_TYPES } from '../utils/constants';
import { searchStudents } from './getGradebook';
import { exceptionGroupsStudentIdsSelector } from '../selectors/search-gradebook';

export const updateAssignmentAverages =
  (assignmentIds) => async (dispatch, getState) => {
    const {
      gradebook: { courseId, searchPhrase, searchType, roster },
    } = getState();
    const studentIds = exceptionGroupsStudentIdsSelector(getState());

    await dispatch(
      updateAverages(
        courseId,
        assignmentIds,
        studentIds,
        searchPhrase,
        searchType,
        roster,
      ),
    );
  };

export const updateAllAverages = () => async (dispatch, getState) => {
  const {
    gradebook: { courseId, averages, searchPhrase, searchType, roster },
  } = getState();
  const studentIds = exceptionGroupsStudentIdsSelector(getState());

  const assignmentIds = _map(averages, (average) => average.assignmentId);
  await dispatch(
    updateAverages(
      courseId,
      assignmentIds,
      studentIds,
      searchPhrase,
      searchType,
      roster,
    ),
  );
};

const updateAverages =
  (courseId, assignmentIds, userIds, searchPhrase, searchType, roster) =>
  async (dispatch) => {
    const userIdsForAveragesUpdate = determineUserIdsForAveragesUpdate(
      userIds,
      searchPhrase,
      searchType,
      roster,
    );
    try {
      const response = await lmsService.getGradebookAverages(courseId, {
        assignmentIds,
        userIds: userIdsForAveragesUpdate,
      });

      const averages = _get(response, 'averages', []);
      const payload = { averages };

      dispatch({
        type: actions.GET_GRADEBOOK_AVERAGES_SUCCESS,
        payload,
      });
    } catch (e) {
      dispatch({
        type: actions.APP_ERROR,
        payload: e,
      });
      throw e;
    }
  };

const determineUserIdsForAveragesUpdate = (
  userIds,
  searchPhrase,
  searchType,
  roster,
) => {
  if (
    roster &&
    searchPhrase?.trim() &&
    searchType !== SEARCH_TYPES.ASSIGNMENTS
  ) {
    const relevantRoster = userIds?.length
      ? roster.filter(({ studentId }) => userIds.includes(studentId))
      : roster;

    const students = searchStudents(relevantRoster, searchPhrase);
    return students.map(({ studentId }) => studentId);
  }

  return userIds;
};
